import React, { createContext, useContext,memo } from 'react';
import { getCurrentUser, signIn, signOut, confirmResetPassword, resetPassword, updatePassword  } from 'aws-amplify/auth'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ROUTES from '../constants/routes.js';
import { useDispatch } from 'react-redux';
import { saveEmail } from '../redux/actions/authActions.js';
import { toggleSnackbar } from '../redux/actions/authActions.js';

const AuthContext = createContext();
export const AuthProvider =memo( ({ children }) => {
  const navigate = useNavigate();
  const dispatch=useDispatch()

  const getCurrentUserInfo = () => {
    getCurrentUser()
      .then((user) => {
        // console.log(user);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const login = async (username, password, changeLoading, redirectPath) => {
    try {
      changeLoading(true);
      const { nextStep } = await signIn({ username, password });

      if (nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        const newPassword = prompt('New Password Required');
        try {
          await confirmResetPassword({ username, newPassword });
          dispatch(saveEmail(username));
          navigate(redirectPath.replace("email=EMAIL", `email=${username}`), { replace: true });
        } catch (e) {
          toast.error(e.message);
          navigate(ROUTES.AGENT.LOGIN, { state: { path: redirectPath } });
        }
      } 
      else if (nextStep.signInStep === 'DONE') {
        dispatch(saveEmail(username));
        navigate(redirectPath.replace("email=EMAIL", `email=${username}`), { replace: true });
      }
      else {
        console.log('Additional sign-in steps required:', nextStep);
      }
    } catch (e) {
      console.error('Login error', e);
      dispatch(toggleSnackbar({ message: 'Incorrect Username or Password', status: true, severity: 'error' }));
      toast.error(e.message);
      navigate(ROUTES.AGENT.LOGIN, { state: { path: redirectPath } });
    } finally {
      changeLoading(false);
    }
  };

  const sendCode = async (username) => {
    try {
      await resetPassword({username});
      toast.success('Code sent successfully');
    } catch (err) {
      console.error("Error during resetPassword:", err); // <-- Important
      toast.error(err.message);
    }
  };

  const changePassword = (oldpassword, newpassword) => {
    getCurrentUser()
      .then((user) => {
        return updatePassword(user, oldpassword, newpassword);
      })
      .then((data) => {
        toast.success('Password changed successfuly');
        
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const validatePassword = async (username, code, new_password) => {
    try {
      await confirmResetPassword({username, code, new_password});
      toast.success('Password changed successfully');
      navigate(ROUTES.AGENT.LOGIN);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const logout = () => {
    signOutUser();
  };

  async function signOutUser() {
    try {
      await signOut();
      window.location.reload(true);
      navigate('/');
    } catch (error) {
      toast.error(error.message);
    }
  }

  return (
    <AuthContext.Provider
      value={{
        login,
        logout,
        validatePassword,
        sendCode,
        changePassword,
        getCurrentUserInfo
      }}
    >
      {children}
    </AuthContext.Provider>
  );
});

export const useAuth =() => {
  return useContext(AuthContext);
};
